<template>
  <div class="d-flex flex-column justify-center align-center lang-disabled ga-4">
    <div class="d-flex flex-column ga-2">
      <div class="title">
        {{$t('Язык отключён')}}
      </div>
      <div class="sub-title">
        {{$t('Язык отключён в настройках. Чтобы изменения отразились на публичной странице, опубликуйте изменения')}}
      </div>
    </div>
    <div class="d-flex flex-column ga-2 w-100">
      <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="enable">
        {{$t('Включить язык')}}
      </v-btn>
      <v-btn variant="outlined" color="accent" rounded="lg" class="w-100" @click="reset">
        {{$t('Удалить язык')}}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useTapStore} from "@/stores/tapStore";
import {useDialogStore} from "@/stores/dialogStore";
import RemoveLanguage from "@/components/dialogs/RemoveLanguage.vue";

const tapStore = useTapStore();
const dialogStore = useDialogStore();

const enable = () => {
  tapStore.toggleLang(tapStore.currentTapLang?.lang)
}
const reset = () => {
  dialogStore.open(RemoveLanguage)
}
</script>

<style scoped lang="sass">
.lang-disabled
  flex: 1
  background: #FFFFFF
  border-radius: 20px
  padding: 0 20px
  margin-bottom: 8px
.title
  color: #363636
  text-align: center
  font-size: 20px
  font-weight: 600
  line-height: normal
.sub-title
  color: #363636
  text-align: center
  font-size: 16px
  font-weight: 400
  line-height: 130%
  max-width: 318px
</style>
